import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { GlobalMsg, GlobalMessageBox_Error_Z721C83C5, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { union_type, class_type, record_type, list_type, bool_type, obj_type, lambda_type, unit_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { News_LatestNewsListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { map, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Page } from "../News/Types.fs.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";
import { navigationArrow, bfsTile } from "../Shared/Tile.fs.js";
import * as react from "react";
import { spinner } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";

export class Model extends Record {
    constructor(GlobalDispatch, NavigateTo, Loading, Data) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.NavigateTo = NavigateTo;
        this.Loading = Loading;
        this.Data = Data;
    }
}

export function Model_$reflection() {
    return record_type("Dashboard.News.Model", [], Model, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["NavigateTo", lambda_type(obj_type, unit_type)], ["Loading", bool_type], ["Data", list_type(News_LatestNewsListItem_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadData", "LoadDataCompleted", "NavigateToList", "NavigateToNews"];
    }
}

export function Msg_$reflection() {
    return union_type("Dashboard.News.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(News_LatestNewsListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(News_LatestNewsListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", class_type("System.Guid")]]]);
}

export function Http_loadFiles() {
    const response = fetch("/api/news/latestNews", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(News_LatestNewsListItem_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function State_init(props) {
    return [new Model(props.GlobalDispatch, props.NavigateTo, true, empty()), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Die News können zur Zeit leider nicht geladen werden.")]));
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, model.Data), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, msg.fields[0].fields[0]), Cmd_none()];
            }
        case 2: {
            model.NavigateTo(new Page(0, [1]));
            return [model, Cmd_none()];
        }
        case 3: {
            model.NavigateTo(new Page(1, [msg.fields[0]]));
            return [model, Cmd_none()];
        }
        default:
            return [new Model(model.GlobalDispatch, model.NavigateTo, false, model.Data), request(Http_loadFiles, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

export const View = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Dashboard\\News.fs") + "#L") + int32ToString(value(68))) + ";") + "Dashboard.Shared.DashboardProps", value("View"), (props) => {
    let entries, children_14;
    let patternInput;
    const init = State_init(props);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, State_update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    return bfsTile("News", react.createElement("a", {
        onClick: (_arg_2) => {
            dispatch(new Msg(2, []));
        },
    }, navigationArrow), undefined, model_1.Loading ? spinner : ((entries = map((data) => {
        let children_4;
        const children_10 = [(children_4 = [react.createElement("b", {}, data.Titel)], react.createElement("p", {}, ...children_4)), react.createElement("p", {
            className: "subtle news-text mt-1",
        }, data.Textanfang), react.createElement("a", {
            onClick: (_arg_3) => {
                dispatch(new Msg(3, [data.Id]));
            },
            className: "is-size-7 news-link",
        }, "Weiterlesen")];
        return react.createElement("li", {}, ...children_10);
    }, model_1.Data), (children_14 = [react.createElement("ul", {}, ...entries)], react.createElement("div", {
        className: "news",
    }, ...children_14)))), undefined);
}, undefined, undefined, "Of");

//# sourceMappingURL=News.fs.js.map
